import React, {useState} from 'react'
import usePortal from '../hooks/usePortal'
import {createPortal} from 'react-dom'
import PlayerModal from './PlayerModal'

const Portal = ({id, children}) => {
  const target = usePortal(id)
  return createPortal(
    children,
    target,
  )
}


const UsersModal = ({players, selectedPosition, setSelectedPosition}) => {
  const [selectUser, setSelectedUser] = useState(null)

  if (!players || !players.length) {
    alert('Скоро будут доступны')
    return null
  }

  const getPosition = () => {
    switch (selectedPosition) {
      case 'OP':
        return 'Опорные полузащитники'
      case 'CPL':
        return 'Центральные полузащитники'
      case 'CPR':
        return 'Атакующие полузащитники'
      case 'LP':
        return 'Левые вингеры'
      case 'PP':
        return 'Правые вингеры'
      case 'N':
        return 'Нападающие'
      case 'CZP':
        return 'Правые центральные защитники'
      case 'CZL':
        return 'Левые центральные защитники'
      case 'LZ':
        return 'Левые защитники'
      case 'PZ':
        return 'Правые защитники'
      case 'V':
        return 'Вратари'
      default:
        return ''
    }
  }

  const closeModal = (e) => {
    e.stopPropagation()
    setSelectedPosition('')
  }


  return <>
    {selectUser && <Portal id={'PlayerModal'}>
      <PlayerModal player={selectUser} isUsersModal closeModal={closeModal} setSelectedUser={setSelectedUser} />
    </Portal>}
    <Portal id={'UsersModal'}>
      <div className="modal">
        <div className="modal__overlay" onClick={closeModal}/>
        <div className="modal__content content">
          <button className="modal__close" onClick={closeModal}>Х</button>
          <div className="modal__title">{getPosition(selectedPosition)}</div>
          <div className="modal__players">
            {players.map((player => <div className={'card-player'}
                                         onClick={() => setSelectedUser(player)}
                                         key={player.id}>
              <div className="card-player__image">
                <picture>
                  <source
                    srcSet={
                      `
                    ${player.players.avatar.sourceUrl}  1x,
                    ${player.players.avatar1.sourceUrl}  2x
                    `
                    }
                    type="image/jpeg"
                  />
                  <img src={player.players.avatar.sourceUrl} alt=""/>
                </picture>
                <div className="card-player__number">
                  {player.players.numberplayer}
                </div>
                <div className="card-player__club-logo">
                  <img src={player.players.iconfootbool.sourceUrl} alt=""/>
                </div>
                <div className="card-player__lastName">
                  {player.players.lastname}
                </div>
                <div className="card-player__age">
                  {player.players.agecart}
                </div>
              </div>
            </div>))}
          </div>
        </div>
      </div>
    </Portal>
  </>

}

export default UsersModal
